import React from 'react'

function FeedbackGridRowForTeacher({ term, objectKey, onItemClick, srNo }) {
  var array = JSON.parse("[" + term + "]");
 // console.log(array[0]);
  return (
    <>
      {objectKey !== "Descriptive" ?
        <>
          <div className='grid-row'>
            <div className='column col-fullWidth'>
              <div className='column-content'><strong>{objectKey}</strong></div>
            </div>
          </div>
          {array[0].map((questions, index) => (
            <div className='grid-row' id={'studentInfra' + questions.mafq_auto_id}>
              <div className='column col-srno'>{index + 1}.</div>
              <div className='column col-question'><div className='column-content'>{questions.mafq_question}<em>*</em></div></div>
              <div className='column col-grade'><div className='column-content'><label><input onClick={onItemClick} q_type="Option" questionid={questions.mafq_auto_id} questionanswer={questions.mafq_option1} name={'r1' + questions.mafq_auto_id} type="radio" style={{ width: 'auto' }} /><span style={{ display: questions.mafq_option1.toLowerCase() == "" ? 'none' : 'block' }}> {questions.mafq_option1}</span></label></div></div>
              <div className='column col-grade'><div className='column-content'><label><input onClick={onItemClick} q_type="Option" questionid={questions.mafq_auto_id} questionanswer={questions.mafq_option2} name={'r1' + questions.mafq_auto_id} type="radio" style={{ width: 'auto' }} /><span style={{ display: questions.mafq_option2.toLowerCase() == "" ? 'none' : 'block' }}> {questions.mafq_option2}</span></label></div></div>
              <div className='column col-grade'><div className='column-content'><label><input onClick={onItemClick} q_type="Option" questionid={questions.mafq_auto_id} questionanswer={questions.mafq_option3} name={'r1' + questions.mafq_auto_id} type="radio" style={{ width: 'auto' }} /><span style={{ display: questions.mafq_option3.toLowerCase() == "" ? 'none' : 'block' }}>{questions.mafq_option3}</span></label></div></div>
              <div className='column col-grade'><div className='column-content'><label><input onClick={onItemClick} q_type="Option" questionid={questions.mafq_auto_id} questionanswer={questions.mafq_option4} name={'r1' + questions.mafq_auto_id} type="radio" style={{ width: 'auto' }} /><span style={{ display: questions.mafq_option4.toLowerCase() == "" ? 'none' : 'block' }}>{questions.mafq_option4}</span></label></div></div>
              <div className='column col-grade'><div className='column-content'><label><input onClick={onItemClick} q_type="Option" questionid={questions.mafq_auto_id} questionanswer={questions.mafq_option5} name={'r1' + questions.mafq_auto_id} type="radio" style={{ width: 'auto' }} /><span style={{ display: questions.mafq_option5.toLowerCase() == "" ? 'none' : 'block' }}>{questions.mafq_option5}</span></label></div></div>
            </div>
          ))
          }
        </>
        :
        <>
          {
            array[0].map((questions, index) => (
              <div className='grid-row grid-row-seperate' id={'studentInfra' + questions.mafq_auto_id}>
                <div className='column col-srno'>{index + 1}</div>
                <div className='column col-fullWidthQuestion'>
                  <div className='column-content'>{questions.mafq_question}<br />
                    <textarea id="textarea1" class='textarea' rows="2" placeholder="Remarks, if any" onChange={onItemClick} q_type="Descriptive" questionid={questions.mafq_auto_id}></textarea>
                  </div>
                </div>
              </div>
            ))
          }
        </>
      }


    </>
  );
}
export default React.memo(FeedbackGridRowForTeacher);